__turbopack_context__.v({
  "loader-container": "loader-module-scss-module__fTBtZW__loader-container",
  "loader-spinner": "loader-module-scss-module__fTBtZW__loader-spinner",
});
